//  <Icons name="TgBlue" classNameIcons="inline-block ml-1 dark:hidden " />
// clrIc="#ffffff" цвет иконки

const Icons = ({ name, classNameIcons, clrIc }) => {

    const spinnerIcon = (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNameIcons}>
            <style>
                {`.spinner_qM83{animation:spinner_8HQG 1.05s infinite}.spinner_oXPr    {animation-delay:.1s}.spinner_ZTLf{animation-delay:.1s}@keyframes spinner_8HQG{0%,57.14%{animation-timing-function:cubic-bezier(0.33,.66,.66,1);transform:translate(0)}28.57%{animation-timing-function:cubic-bezier(0.33,0,.66,.33);transform:translateY(-6px)}100%{transform:translate(0)}}`}
            </style>
            <circle className="spinner_qM83" cx="3" cy="12" r="3" fill="#ea4406" /><circle className="spinner_qM83 spinner_oXPr" cx="12" cy="12" r="3" fill="#eab306" /><circle className="spinner_qM83 spinner_ZTLf" fill="#22c55e" cx="20" cy="12" r="3" />
        </svg>
    );

    const tgIconBlue = (
        <svg className={classNameIcons} xmlns="http://www.w3.org/2000/svg" aria-label="Telegram" role="img" viewBox="0 0 512 512" width="24px" height="24px" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="512" height="512" rx="15%" fill="#37aee2"></rect><path fill="#c8daea" d="M199 404c-11 0-10-4-13-14l-32-105 245-144"></path><path fill="#a9c9dd" d="M199 404c7 0 11-4 16-8l45-43-56-34"></path><path fill="#f6fbfe" d="M204 319l135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"></path></g></svg>
    );
    const tgIconDark = (
        <svg className={classNameIcons} xmlns="http://www.w3.org/2000/svg" aria-label="Telegram" role="img" viewBox="0 0 512 512" width="24px" height="24px" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="512" height="512" rx="15%" fill="rgb(55 65 81)"></rect><path fill="#c8daea" d="M199 404c-11 0-10-4-13-14l-32-105 245-144"></path><path fill="#a9c9dd" d="M199 404c7 0 11-4 16-8l45-43-56-34"></path><path fill="#f6fbfe" d="M204 319l135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"></path></g></svg>
    );

    const OfferStatus_NewIcon = (
        <svg className={"w-6 h-6 transition-all duration-300 " + classNameIcons} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 17.27L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const OfferStatus_ViewedIcon = (
        <svg className={"w-6 h-6 transition-all duration-300 " + classNameIcons} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9C13.1 9 14 9.9 14 11C14 12.1 13.1 13 12 13C10.9 13 10 12.1 10 11C10 9.9 10.9 9 12 9ZM12 4C16.97 4 21.02 7.07 22.49 11C21.02 14.93 16.97 18 12 18C7.03 18 2.98 14.93 1.51 11C2.98 7.07 7.03 4 12 4Z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    // const OfferStatus_InProgressIcon = (
    //     <>
    //         <svg class="car-icon" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={"1.5"} strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" fill={clrIc ? clrIc : "none"}>
    //             <style>{`

    //     .wheel {
    //         animation: rotate 3s linear infinite;
    //         filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.7));
    //     }
    //     .spoke { stroke: #A66C2; stroke-width: 1; }
    //     .car-body {
    //         animation: pulse 1s infinite;
    //         transform-origin: center;
    //     }
    //     @keyframes rotate {
    //         from {
    //             transform: rotate(0deg);
    //         }
    //         to {
    //             transform: rotate(360deg);
    //         }
    //     }

    //     @keyframes pulse {
    //         0% {
    //             box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
    //         }
    //         70% {
    //             box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);
    //         }
    //         100% {
    //             box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
    //         }
    //     }
    //                  `}</style>
    //             {/* Кузов автомобиля */}
    //             <path class="car-body" d="M3 13.5h1.5l1.2-3.2A2 2 0 0 1 6.6 8.5h8.8a2 2 0 0 1 1.9 1.3L19.5 13.5H22" />
    //             <path class="car-body" d="M6.2 8.5l1-2h6.6l1 2" />

    //             {/* Переднее колесо */}
    //             <g transform="translate(30,35)">
    //                 <circle  r="7" />
    //                 <line class="spoke" x1="0" y1="-7" x2="0" y2="7" />
    //                 <line class="spoke" x1="-7" y1="0" x2="7" y2="0" />
    //                 <line class="spoke" x1="-5" y1="-5" x2="5" y2="5" />
    //                 <line class="spoke" x1="5" y1="-5" x2="-5" y2="5" />
    //                 <animateTransform attributeName="transform" type="rotate" from="0 0 0" to="360 0 0"
    //                     dur="1s" repeatCount="indefinite" />
    //             </g>

    //             {/* Заднее колесо */}
    //             <circle class="wheel" cx="17" cy="17" r="2.5" />


    //         </svg>
    //     </>
    // );
    //     const OfferStatus_InProgressIcon = (
    //         <>
    //             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 50" width="100" height="50">
    //                 <style>{`
    //                     .car {stroke: black; stroke-width: 2; fill: none; }
    //                     .wheel {stroke: #A66C2; stroke-width: 2; fill: none; }
    //                     .spoke {stroke: #A66C2; stroke-width: 1; }
    //                 `}</style>

    //                 {/* <!-- Тело автомобиля --> */}
    //                 <path class="car" d="
    //     M 15 35
    //     L 25 25
    //     L 40 25
    //     L 45 30
    //     L 60 30
    //     L 70 20
    //     L 85 20
    //     L 85 35
    //     Z
    //   " />

    //                 {/* <!-- Заднее колесо --> */}
    //                 <g><circle class="wheel" r="7" cx="70" cy="45"></circle><line class="spoke" x1="70" y1="52" x2="70" y2="38"></line><line class="spoke" x1="63" y1="45" x2="77" y2="45"></line><line class="spoke" x1="65" y1="40" x2="75" y2="50"></line><line class="spoke" x1="75" y1="40" x2="65" y2="50"></line><animateTransform attributeName="transform" type="rotate" from="0 70 45" to="360 70 45" dur="4s" repeatCount="indefinite"></animateTransform></g>

    //                 {/* <!-- Переднее колесо --> */}
    //                 <g transform="translate(70,35)">
    //                     <circle class="wheel" r="7" />
    //                     <line class="spoke" x1="0" y1="-7" x2="0" y2="7" />
    //                     <line class="spoke" x1="-7" y1="0" x2="7" y2="0" />
    //                     <line class="spoke" x1="-5" y1="-5" x2="5" y2="5" />
    //                     <line class="spoke" x1="5" y1="-5" x2="-5" y2="5" />
    //                     <animateTransform attributeName="transform" type="rotate" from="0 0 0" to="360 0 0"
    //                         dur="1s" repeatCount="indefinite" />
    //                 </g>
    //             </svg>
    //         </>
    //     );
    const OfferStatus_InProgressIcon = (
        <svg className="w-6 h-6 transition-all duration-300 group-hover:scale-125" viewBox="0 0 24 16" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {/* Car body */}
            <path d="M0.5 6a2 2 0 0 1 1.8 -2l1.2-3A2 2 0 0 1 5 0.5h8a2 2 0 0 1 1.5 0.5L18.5 5l3.5 0.5a2 2 0 0 1 1.5 2l0 1.5a1 1 0 0 1 -1.4 1m-6 0 h-8 m-6 0h-1.6v-4"></path>

            {/* <!-- Заднее колесо --> */}
            <g>
                <circle className="wheel" r="3" cx="5" cy="11"></circle>
                <line className="spoke" x1="5" y1="8" x2="5" y2="14" stroke="#ff0000"></line>
                <line className="spoke" x1="3" y1="9" x2="7" y2="13" stroke="#0000ff"></line>
                <line className="spoke" x1="2" y1="11" x2="8" y2="11" stroke="#00ff00"></line>
                <line className="spoke" x1="7" y1="9" x2="3" y2="13"></line>

                <animateTransform attributeName="transform" type="rotate" from="0 5 11" to="360 5 11" dur="2s" repeatCount="indefinite"></animateTransform>
            </g>
            {/* <!-- Переднее колесо --> */}
            <g>
                <circle className="wheel" r="3" cx="19" cy="11"></circle>
                <line className="spoke" x1="16" y1="11" x2="22" y2="11" stroke="#00ff00"></line>
                <line className="spoke" x1="19" y1="8" x2="19" y2="14" stroke="#ff0000"></line>
                <line className="spoke" x1="17" y1="9" x2="21" y2="13" stroke="#0000ff"></line>
                <line className="spoke" x1="21" y1="9" x2="17" y2="13"></line>
                <animateTransform attributeName="transform" type="rotate" from="0 19 11" to="360 19 11" dur="2s" repeatCount="indefinite"></animateTransform>
            </g>
        </svg>
    );
    const OfferStatus_RejectedIcon = (
        <svg className={"w-6 h-6 transition-all duration-300 " + classNameIcons} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3L21 21M21 3L3 21" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const OfferStatus_ArchivedIcon = (
        <svg className={"w-6 h-6 transition-all duration-300 " + classNameIcons} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V8L14 2H6C4.9 2 4 2.9 4 4ZM12 2V8H20" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const namesIcons = {
        Spinner: spinnerIcon,
        TgBlue: tgIconBlue,
        TgDark: tgIconDark,
        NewIcon: OfferStatus_NewIcon,
        ViewedIcon: OfferStatus_ViewedIcon,
        inProgressIcon: OfferStatus_InProgressIcon,
        RejectedIcon: OfferStatus_RejectedIcon,
        ArchivedIcon: OfferStatus_ArchivedIcon,
        // Add more icons here as needed
    };

    return (
        <>
            {/*  {namesIcons[name] && ({`${namesIcons[name]}`})} */}
            {namesIcons[name] && namesIcons[name]}
        </>
    )
}

export default Icons